import axios from '../../axios/index.js'

export default {
    getSelectOptions (data) {
      return axios.get('getSelectOptions',{params:data})
    }
}
  